export const initialState = {
    metrics: null,
    isLoading: false,
    isLoaded: false,
    error: null,
    metaData: {
        digestSubscriptionInfo: {
            isSubscribed: false,
        },
        isLoading: false,
    },
    assets: { images: {}, isImagesFetched: false },
    contextMenu: { isLoading: false, pdfState: { error: null } },
    competitorsModal: {
        competitors: null,
        isLoading: false,
    },
    subscriptionModal: {
        isOpen: false,
        isLoading: false,
    },
    audienceReachAutoDuration: "",
};
